import { useContext, useState, useEffect } from "react";
import { withRouter } from "./withRouter";
import { Outlet, Navigate, useNavigate, useLocation } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Box, Container } from "@mui/material";
import { CircularProgress } from "@material-ui/core";
import { theme } from "../theme";
import { GlobalContext } from "../context/Provider";
import { SECRET_KEY } from "../constants/encriptKey";
import { getDecryptedDataFromSessionStorage } from "../utils";
import { getUserRole } from "../context/actions/auth/getUserRole";

function PrivateRoute({ allowedRole, redirectPath = "/backoffice" }) {
  const { roleUser, setRoleUser } = useContext(GlobalContext);
  const navigate = useNavigate();
  const location = useLocation();

  const rutasOmitidas = [
    "/",
    "/dashboard",
    "/my-info",
    "/reset-my-pass",
    "/my-prescriptions/new",
    "/my-patients/edit/:idPaciente",
    "/my-patients/view/:idPaciente",
    "/my-patients",
    "/my-patients/new",
    "/my-prescriptions",
  ];

  const decryptedData = getDecryptedDataFromSessionStorage(SECRET_KEY);
  const initialAuthState = decryptedData?.accessToken ? true : false;
  const [auth, setAuth] = useState(initialAuthState);
  const [loading, setLoading] = useState(true);
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const start = performance.now(); // inicio del loading
      if (!rutasOmitidas.includes(location.pathname)) {
        try {
          const { id, accessToken } = decryptedData;
          if (!id || !accessToken) {
            setLoading(false);
            return;
          }
          const response = await getUserRole({ idUsuario: id }, accessToken);
          const { result } = response;
          setRoleUser(result.idRol);
        } catch (error) {
          console.error("Error al obtener el rol del usuario:", error);
        } finally {
          const duration = performance.now() - start;
          const minDuration = 800;
          if (duration < minDuration) {
            setTimeout(() => setLoading(false), minDuration - duration);
          } else {
            setLoading(false);
          }
        }
      } else {
        setLoading(false);
      }
    };

    fetchData();
  }, [decryptedData, rutasOmitidas]);

  useEffect(() => {
    if (!allowedRole.includes(Number(roleUser))) {
      if (roleUser === 2) {
        navigate("/medical-staff", { replace: true });
      } else if (roleUser === 1) {
        navigate("/home", { replace: true });
      } else if (roleUser === 3) {
        navigate("/logs", { replace: true });
      }
    }
  }, [roleUser, loading, allowedRole, navigate]);

  // showLoading sigue el estado de loading
  useEffect(() => {
    if (!loading) {
      setShowLoading(false);
    }
  }, [loading]);

  if (showLoading) {
    return (
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          marginTop: 20,
        }}
      >
        <Container maxWidth="sm">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <CircularProgress />
          </Box>
        </Container>
      </Box>
    );
  }
  return auth ? (
    <div style={{ display: "flex", background: "white" }}>
      <MuiThemeProvider theme={theme}>
        <Outlet />
      </MuiThemeProvider>
    </div>
  ) : (
    <Navigate to={redirectPath} replace />
  );
}

export default withRouter(PrivateRoute);
